export default "{\n    \"title\": \"Preventative Maintenance Details\",\n    \"breadcrumbsParentLinkText\": \"Preventative Maintenance\"\n}\n"